import DomainCommon from './common';

const GcsFileService = {
  getUploadUrl: ({ type, subtype }) => {
    return new Promise((resolve, reject) => {
      return DomainCommon.fetchPost({
        url: `${DomainCommon.getUecareApiUrl()}/gcsFile/url/upload/${type}`,
        jsonBody: { subtype },
        resolve,
        reject,
      });
    });
  },
  getDownloadUrl: ({ type, subtype }) => {
    return new Promise((resolve, reject) => {
      return DomainCommon.fetch({
        url: `${DomainCommon.getUecareApiUrl()}/gcsFile/url/download/${type}?${DomainCommon.buildQueryString({ subtype })}`,
        resolve,
        reject,
      });
    });
  },
  getDownloadUrlByMission: (missionId) => {
    return new Promise((resolve, reject) => {
      return DomainCommon.fetch({
        url: `${DomainCommon.getUecareApiUrl()}/gcsFile/url/download/mission?${DomainCommon.buildQueryString({ missionId })}`,
        resolve,
        reject,
      });
    });
  },
};

export default GcsFileService;



// WEBPACK FOOTER //
// ./src/service/gcsFile.js